import { articles } from "@/mocks/articles";

export default function Ticker() {
  const items = [...articles, ...articles];

  return (
    <div className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto flex w-full items-center gap-3 px-4 py-3 md:px-8">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-500 text-background-50">
          <i className="ri-stack-line"></i>
          最新更新
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-ticker items-center gap-10">
            {items.map((a, idx) => (
              <span key={`${a.id}-${idx}`} className="flex items-center gap-2 whitespace-nowrap text-sm text-foreground-700">
                <i className="ri-record-circle-line text-[8px] text-primary-500"></i>
                <span className="text-foreground-500">{a.date}</span>
                {a.title}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}